export function getJobStatusLabel(status: string): string {
  switch (status) {
    case 'OPEN':
      return 'Offen';
    case 'IN_PROGRESS':
      return 'In Arbeit';
    case 'DONE':
      return 'Erledigt';
    case 'CANCELLED':
      return 'Abgebrochen';
    default:
      return status;
  }
}

export function getJobStatusColors(status: string): { bg: string; text: string } {
  switch (status) {
    case 'OPEN':
      return { bg: '#dbeafe', text: '#1e40af' };
    case 'IN_PROGRESS':
      return { bg: '#fef3c7', text: '#92400e' };
    case 'DONE':
      return { bg: '#d1fae5', text: '#065f46' };
    case 'CANCELLED':
      return { bg: '#f3f4f6', text: '#374151' };
    default:
      return { bg: '#f3f4f6', text: '#374151' };
  }
}

export function getMilestoneStatusInfo(status: string): { label: string; bg: string; text: string } {
  switch (status) {
    case 'READY_FOR_INVOICE':
      return { label: 'Bereit zur Rechnung', bg: '#d1fae5', text: '#065f46' };
    case 'INVOICED':
      return { label: 'Rechnung erstellt', bg: '#dbeafe', text: '#1e40af' };
    case 'PAID':
      return { label: 'Bezahlt', bg: '#f0fdf4', text: '#166534' };
    case 'IN_PROGRESS':
      return { label: 'In Arbeit', bg: '#fef3c7', text: '#92400e' };
    case 'OPEN':
    default:
      return { label: 'Offen', bg: '#f3f4f6', text: '#374151' };
  }
}

export function formatDateDE(dateStr?: string): string {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatDateShortDE(dateString?: string): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: '2-digit' });
}
